<div class="create-file-dialog dialog">
  <div class="create-file-dialog-header dialog-header">
    <h5>{{dialogTitle}}</h5>
    <span class="create-file-dialog-header-close dialog-close" (click)="close()" (keypress)="close()">
      <img alt="close" [src]="'images/close.svg' | assetUrl" class="black-icon cursor-pointer" draggable="false">
    </span>
  </div>
  <mat-dialog-content class="create-file-dialog-content dialog-content">
    <form class="file-name-form" [formGroup]="inputForm">
      <div class="file-name-form-input">
        <input [placeholder]="buttonName === 'folder' ? 'Add Folder' : 'Name'" formControlName="folderName">
      </div>
      @if (inputForm.controls['folderName'].invalid && inputForm.controls['folderName'].touched) {
        <mat-error class="file-name-form-input-error"
          >Name
          is
        required</mat-error>
      }

      <button type="submit" class="file-name-form-button"
        mat-raised-button color="primary" (click)="returnResult()">
        {{buttonName === 'folder' ? 'Create' : buttonName}}
      </button>
    </form>
  </mat-dialog-content>

</div>